module.exports = __webpack_public_path__ + "static/media/Telus_One_page-18.06e72df8.png";